// Active Ingredients Section Mobile - Carousel JavaScript
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.ain-ingredients-carousel');
    const slides = Array.from(carousel.querySelectorAll('.ain-ingredient-block'));
    const prevButton = document.querySelector('.ain-carousel-prev-button');
    const nextButton = document.querySelector('.ain-carousel-next-button');
    let currentIndex = 0;
  
    const offsetPx = 420; /* 400px card width + 20px gap */
  
    function updatePositions() {
      slides.forEach((slide, i) => {
        const diff = i - currentIndex;
        const scale = (diff === 0) ? 1 : 1;
        const xOffset = diff * offsetPx;
        slide.style.transform = `translate(-50%, -50%) translateX(${xOffset}px) scale(${scale})`;
        slide.style.zIndex = (diff === 0) ? 10 : 5;
        slide.style.opacity = (Math.abs(diff) > 1) ? 0 : 1;
      });
    }
  
    updatePositions();
  
    // Tap/Click event to navigate by clicking on the side blocks
    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        currentIndex = i;
        updatePositions();
        updateNavButtons();
      });
    });
  
    // Swipe functionality
    let startX = 0;
    let isTouching = false;
  
    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isTouching = true;
    });
  
    carousel.addEventListener('touchend', (e) => {
      if (!isTouching) return;
      const endX = e.changedTouches[0].clientX;
      const diffX = endX - startX;
      if (diffX < -50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (diffX > 50 && currentIndex > 0) {
        currentIndex--;
      }
      updatePositions();
      updateNavButtons();
      isTouching = false;
    });
  
    // For desktop: mouse drag support (optional)
    let isDown = false;
    let startDragX = 0;
  
    carousel.addEventListener('mousedown', (e) => {
      e.preventDefault();
      startDragX = e.clientX;
      isDown = true;
    });
  
    document.addEventListener('mouseup', (e) => {
      if (!isDown) return;
      const diffX = e.clientX - startDragX;
      if (diffX < -50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (diffX > 50 && currentIndex > 0) {
        currentIndex--;
      }
      updatePositions();
      updateNavButtons();
      isDown = false;
    });
  
    // Navigation Buttons Functionality
    prevButton.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updatePositions();
        updateNavButtons();
      }
    });
  
    nextButton.addEventListener('click', () => {
      if (currentIndex < slides.length - 1) {
        currentIndex++;
        updatePositions();
        updateNavButtons();
      }
    });
  
    // Disable buttons when at the ends
    function updateNavButtons() {
      if (currentIndex === 0) {
        prevButton.style.opacity = 0.5;
        prevButton.style.cursor = 'not-allowed';
      } else {
        prevButton.style.opacity = 1;
        prevButton.style.cursor = 'pointer';
      }
  
      if (currentIndex === slides.length - 1) {
        nextButton.style.opacity = 0.5;
        nextButton.style.cursor = 'not-allowed';
      } else {
        nextButton.style.opacity = 1;
        nextButton.style.cursor = 'pointer';
      }
    }
  
    // Initial call to set button states
    updateNavButtons();
  });
})();
